import { defineComponent } from 'vue';
export default defineComponent({
    name: 'ContainerTitle',
    props: {
        containerTitle: {
            type: String,
            required: true,
        },
    },
});
